export default ['right', 'top', 'bottom', 'left']
